import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-141b0c22"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "container-lg container-fluid mt-3 pt-2"
}
const _hoisted_2 = { class: "page container-lg container-fluid" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "text-primary" }, "Evaluation form for innovation proposals"),
  /*#__PURE__*/_createElementVNode("h6", { class: "align-self-end me-4" }, "Program Coordinators")
], -1))
const _hoisted_5 = { class: "mt-4 mb-5" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 mb-3 p_heading" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "my-3" }, "Submitted Innovation Proposal", -1))
const _hoisted_9 = { class: "my-2" }
const _hoisted_10 = { class: "col-md-6 mb-3 p_heading" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "my-3" }, "Health Priority Needs", -1))
const _hoisted_12 = { class: "my-2" }
const _hoisted_13 = { class: "h-100 d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "me-2 bi bi-printer-fill" }, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "grey_section py-4"
}
const _hoisted_16 = { class: "container-lg container-fluid" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "my-2" }, "1.1 Goals, scope and description", -1))
const _hoisted_18 = { class: "grey_section_text" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "1.2 Innovative Description", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Funds raised till date", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Personal Description", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Challenges", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Potential", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Uniqueness of System", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Critical Next Steps", -1))
const _hoisted_26 = { class: "attached_files" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Attached files", -1))
const _hoisted_28 = {
  type: "1",
  class: "text-primary"
}
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 3,
  class: "container-lg container-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Form = _resolveComponent("Form")!
  const _component_FormModal = _resolveComponent("FormModal")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.EvaluateId === '')
      ? (_openBlock(), _createBlock(_component_Header, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.data?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"5rem"},
            class: "my-5"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"40vh"},
            class: "mb-3"
          }),
          _createVNode(_component_Skeleton, {
            width: "100%",
            style: {"height":"5rem"},
            class: "mb-3"
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data?.id)
        ? (_openBlock(), _createElementBlock("main", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("section", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.data?.proposal_details?.solution_title), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.need?.title), 1),
                  _createVNode(_component_Button, {
                    onClick: _withModifiers(_ctx.gotoNeed, ["prevent"]),
                    class: "p-button-text p-button-raised",
                    label: "Click here to read on the health priority needs",
                    "aria-label": "Goto Need"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Button, {
                  class: "p-button-text",
                  label: "Print to PDF",
                  onclick: "window.print()",
                  style: {"margin-left":"1rem"},
                  "aria-label": "Print Screen"
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data?.id)
      ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.datasValue.description), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.solution_description || "----"), 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_19,
              _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.personal_description || "----"), 1)
            ]),
            _hoisted_20,
            _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.proposal_details?.funds_raised || "----"), 1),
            _hoisted_21,
            _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.proposal_details?.personal_description || "----"), 1),
            _hoisted_22,
            _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.proposal_details?.scale_challenges || "----"), 1),
            _hoisted_23,
            _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.proposal_details?.scale_potential || "----"), 1),
            _hoisted_24,
            _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.proposal_details?.solution_uniqueness || "----"), 1),
            _hoisted_25,
            _createElementVNode("p", null, _toDisplayString(_ctx.datasValue?.proposal_details?.critical_next_steps || "----"), 1),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("ol", _hoisted_28, [
                (_ctx.data?.proposal_details?.reference_letter_doc)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (
              _ctx.handleFile(_ctx.data?.proposal_details?.reference_letter_doc)
            ), ["prevent"]))
                    }, [
                      _createElementVNode("img", {
                        src: 
                require(`@/assets/placeholder/${_ctx.getFileExt(
                  _ctx.data?.proposal_details?.reference_letter_doc
                )}.svg`)
              ,
                        alt: "placeholder_img",
                        width: "15"
                      }, null, 8, _hoisted_29),
                      _createTextVNode(" " + _toDisplayString(_ctx.data?.proposal_details?.reference_letter_doc &&
              _ctx.getFileName(_ctx.data?.proposal_details?.reference_letter_doc)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.data?.proposal_details?.tech_specs_docs)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.handleFile(_ctx.data?.proposal_details?.tech_specs_docs)), ["prevent"]))
                    }, [
                      _createElementVNode("img", {
                        src: 
                require(`@/assets/placeholder/${_ctx.getFileExt(
                  _ctx.data?.proposal_details?.tech_specs_docs
                )}.svg`)
              ,
                        alt: "placeholder_img",
                        width: "15"
                      }, null, 8, _hoisted_30),
                      _createTextVNode(" " + _toDisplayString(_ctx.data?.proposal_details?.tech_specs_docs &&
              _ctx.getFileName(_ctx.data?.proposal_details?.tech_specs_docs)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.data?.proposal_details?.video_upload)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 2,
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.handleFile(_ctx.data?.proposal_details?.video_upload)), ["prevent"]))
                    }, [
                      _createElementVNode("img", {
                        src: 
                require(`@/assets/placeholder/${_ctx.getFileExt(
                  _ctx.data?.proposal_details?.video_upload
                )}.svg`)
              ,
                        alt: "placeholder_img",
                        width: "15"
                      }, null, 8, _hoisted_31),
                      _createTextVNode(" " + _toDisplayString(_ctx.data?.proposal_details?.video_upload &&
              _ctx.getFileName(_ctx.data?.proposal_details?.video_upload)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.data?.id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createVNode(_component_Form, {
            id: _ctx.id,
            onNotLoggedIn: _ctx.handleLogin,
            modal: _ctx.modal,
            onEvaluated: _ctx.onEvaluate
          }, null, 8, ["id", "onNotLoggedIn", "modal", "onEvaluated"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.authStatus === false)
      ? (_openBlock(), _createBlock(_component_FormModal, { key: 4 }))
      : _createCommentVNode("", true),
    (_ctx.EvaluateId === '')
      ? (_openBlock(), _createBlock(_component_Footer, { key: 5 }))
      : _createCommentVNode("", true)
  ], 64))
}